import { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import {
  Container,
  Col,
  Row,
  Button,
  Form,
  Table,
  Modal,
  InputGroup,
  Spinner,
  OverlayTrigger,
  Tooltip,
  Card,
  Pagination
} from "react-bootstrap";
import DashboardHeader from "../DashboardHeader";
import "../css/Dashboard.css";
import "../css/Custom.css";
import "../css/Newpresale.css";
import Footer from "../DashboardFooter";
import Collapse from "react-bootstrap/Collapse";
import { toast, Toaster } from "react-hot-toast";
import { IoIosArrowDown } from "react-icons/io"; // for toggle icon
import {
  getAllPresaleListedByAddress,
  submitWithdrawRequest,
  getLiquidityFormDetailsByUser,
  updateLiquidityTable,
  submitRemoveLiquidityRequest,
  updateDurationAfterChange,
  registerBot,
  updateBot,
  getBotDetails
} from "../../../Action/action";
import {
  LPBalance,
  PoolBalances,
  ReceivableAmountAfterRemovingLiquidity,
  ApproveUsdtToken,
  ApproveToken,
  RemovalStatus,
  getTokenPriceSwap,
  UsdtAmount2,
  AddLiquidity,
  RemoveLiquidity,
  addBotUsdt,
  addBotToken,
  addBotNative,
  getBotTokenBalance,
  getBotUsdtBalance,
  getBotNativeBalance,
  haltBot,
  resumeBot,
  getUserInfiBalance,
  getBotFee,
  getBotStatus,
  removeBotToken,
  removeBotUsdt,
  removeBotNative
} from "../../../Web3/Liquidity/swapConnector";
import Web3WalletProvider from "../../../ConnectWallet/walletProvider";
import { useDisconnect, useAccount } from "wagmi";
import {
  UpdateSaleDuration,
  WithdrawTokens,
  WithdrawStatus2,
  SaleStatus,
  TokenSaleDuration,
} from "../../../Web3/Connector";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import { showLoader, hideLoader } from "../../loader";
import config from "../../../config/config";
import { useParams } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/bootstrap.css';
import { isValidPhoneNumber } from 'libphonenumber-js'

const tokenData = Array(20).fill({
  tokenName: 'MintChain',
  tokenAddress: 'val1q...6pvq',
  purchasedAmount: '$ 5000 MNT',
  currentBalance: '$ 6500 MNT',
});

const ITEMS_PER_PAGE = 9;

const Newpresale = ({ special, clearModalData }) => {
  let { walletAddress } = useParams();
  const [isOpen, setIsOpen] = useState(false); // Collapse toggle
  const [request, setRequest] = useState({
    reason: "",
    duration: "",
    agree: false,
  });
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState([]);
  const _useWeb3WalletProvider = Web3WalletProvider();
  const { address, isConnected } = useAccount();
  const [isProviderLoaded, setisProviderLoaded] = useState(false);
  const [show, setShow] = useState(false);
  const [withdraw, setWithdraw] = useState(false);
  const [selectedItem, setItem] = useState({});

  const handleClose = () => setShow(false);
  const handleShow = (e, item) => {
    e.preventDefault();
    setItem(item);
    setShow(true);
  };

  const handleClose2 = () => setWithdraw(false);
  const handleShow2 = (e, item) => {
    e.preventDefault();
    setItem(item);
    setWithdraw(true);
  };
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {
    if (!isProviderLoaded) {
      _useWeb3WalletProvider.then((data) => {
        if (data) {
          setisProviderLoaded(true);
        }
      });
    }
  }, [_useWeb3WalletProvider]);

  useEffect(() => {
    if (isProviderLoaded) {
      getFormData();
      getLiquidityFormData();
    }
  }, [isProviderLoaded]);

  const getFormData = async () => {
    try {
      walletAddress = address;
      const response = await getAllPresaleListedByAddress({ walletAddress });
      if (response.success) {
        if (response.data.length > 0) {
          let dResult = await TokenSaleDuration(response.data);
          let withdraw = await WithdrawStatus2(response.data);
          let stat = await SaleStatus(response.data);
          for (let i = 0; i < response.data.length; i++) {
            response.data[i].newD = dResult?.duration[i];
            response.data[i].canWithdraw = withdraw?.can[i];
            response.data[i].isActive = stat?.isactive[i];
          }
        }
        setForm(response.data);
        console.log('form2', form)
      }
    } catch (error) {
      console.log(error);
    }
  };

  const validateRequest = async () => {
    const newErrors = {};
    if (!request.reason) newErrors.request = "Reason is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateDuration = async () => {
    const newErrors = {};
    if (!request.duration) newErrors.duration = "Duration is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = async (e) => {
    const { name, value } = e.target;

    setRequest({
      ...request,
      [name]: value,
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleWithdrawal = async (e) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    showLoader();
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        tokenAddress: form[0].token_address,
        preSaleAddress: form[0].presaleContract,
        networkId: form[0].chainNetworkId,
      };

      let res = await WithdrawTokens(request);
      if (res.status) {
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log("Withdrawal Error", error);
      toast.error(error);
    } finally {
      hideLoader();
    }
  };
  const handleWithdrawRequest = async (e) => {
    e.preventDefault();
    if (await validateRequest()) {
      let data = {
        owner_address: address,
        token_name: selectedItem.token_name,
        token_address: selectedItem.token_address,
        reason: request.reason,
        chain: selectedItem.chain,
      };
      console.log("SUB", data);
      let result = await submitWithdrawRequest(data);
      setWithdraw(false);
      setRequest({ reason: "" });
      //console.log('SUB',result)
      if (result.success) {
        toast.success(result.msg);
      } else {
        toast.error(result.msg);
      }
    } else {
      toast.error("Please check validations required");
    }
  };

  const handleUpdateDuration = async (e) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    if (await validateDuration()) {
      showLoader();
      try {
        let input = {
          walletProvider: _useWeb3WalletProvider,
          tokenAddress: selectedItem.token_address,
          preSaleAddress: selectedItem.presaleContract,
          duration: request.duration,
          networkId: selectedItem.chainNetworkId,
        };

        let res = await UpdateSaleDuration(input);
        setShow(false);
        setRequest({ duration: "" });
        if (res.status) {
          toast.success(res.message);
          let data = {
            tokenAddress: input.tokenAddress,
            duration: input.duration,
          };
          await updateDurationAfterChange(data);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          toast.error(res.message);
        }
      } catch (error) {
        console.log("Error Updating duration", error);
        toast.error("Duration Update Error", error);
      } finally {
        hideLoader();
      }
    } else {
      toast.error("Please check validations required");
    }
  };

  //liquidity
  const [liqForm, setLiqForm] = useState([]);
  const [lpAmt, setLpAmt] = useState("");
  const [tokenAmt, setTokenAmt] = useState("");
  const [usdtAmtToAdd, setUsdtAmtToAdd] = useState("");
  const [expected, setExpected] = useState("");
  const [inputError, setInputError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [removeModal, setRemoveModal] = useState(false);
  const [selectedTokenItem, setSelectedTokenItem] = useState({});

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = (e, item) => {
    e.preventDefault();
    setSelectedTokenItem(item);
    setShowModal(true);
  };

  const handleModalShow2 = (e, item) => {
    e.preventDefault();
    setSelectedTokenItem(item);
    setRemoveModal(true);
  };
  const handleModalClose2 = () => setRemoveModal(false);

  //bot

  const [isBotHalted, setIsBotHalted] = useState(() => {
    const stored = localStorage.getItem("isBotHalted");
    return stored === null ? true : stored === "true";
  });

  useEffect(() => {
    if (isBotHalted !== null) {
      localStorage.setItem("isBotHalted", isBotHalted);
    }
  }, [isBotHalted]);


  const getLiquidityFormData = async () => {
    try {
      let walletAddress = address;
      const response = await getLiquidityFormDetailsByUser({ walletAddress });
      console.log('aa', response)
      if (response.success) {
        if (response.data.length > 0) {
          let pb = await PoolBalances(response.data);
          let tp = await getTokenPriceSwap(response.data);
          let lpb = await LPBalance(response.data);
          let remove = await RemovalStatus(response.data);
          let botTokenBal = await getBotTokenBalance(response.data)
          let botUsdtBal = await getBotUsdtBalance(response.data)
          let botNativeBal = await getBotNativeBalance(response.data)
          let botFees = await getBotFee(response.data)
          let botStat = await getBotStatus(response.data)
          for (let i = 0; i < response.data.length; i++) {
            response.data[i].BALANCES = pb.data[i];
            response.data[i].PRICE = tp.data[i];
            response.data[i].LPBAL = lpb.data[i].balance;
            response.data[i].canRemove = remove.data[i];
            response.data[i].botBalToken = botTokenBal.data[i]
            response.data[i].botBalUsdt = botUsdtBal.data[i]
            response.data[i].botBalNative = botNativeBal.data[i]
            response.data[i].botFee = botFees.data[i]
            response.data[i].stat = botStat.data[i]
          }
          setLiqForm(response.data);
          console.log("l2", response.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };


  const [activePage, setActivePage] = useState(1);

  const startIndex = (activePage - 1) * ITEMS_PER_PAGE;
  const paginatedData = tokenData.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const totalPages = Math.ceil(tokenData.length / ITEMS_PER_PAGE);

  const handlePageChange = (pageNumber) => setActivePage(pageNumber);

  return (
    <>
      <Toaster />
      <div className="">
        <div
          className="dashboard w-100"
          style={{ minHeight: "100vh", overflow: "hidden" }}
        >
          <div className="d-flex  w-100 h-100">
            <Sidebar special={special} clearModalData={clearModalData} />

            <div className="w-100" style={{ height: "100%" }}>
              <DashboardHeader />
              <div className="main-panel">
                <div
                  className="content-wrapper px-4 px-lg-4"
                  style={{
                    // padding: "15px",
                    flex: "1",
                    backgroundColor: "#000",
                    color: "#ffffff",
                    height: "100%",
                    overflowY: "auto",
                  }}
                >
                  {isLoading ? (
                    <div className="p-sm-4 text-center">
                      <img
                        src={`${config.baseUrl}images/loader.gif`}
                        width="30px"
                        alt=""
                      />
                    </div>
                  ) :
                    <Container fluid className="my-4">
                      <h5 className="mb-4">Investment Summary by Token</h5>
                      <Row>
                        {paginatedData.map((token, idx) => (
                          <Col key={idx} sm={12} md={6} lg={4} xl={4} className="mb-4">
                            <Card className={`dashboard-card dash-gradient2 overflow-hidden ${idx % 2 === 0 ? 'card-border-info' : 'card-border-orange'}`}>
                              <Card.Body>
                                <div className="d-flex justify-content-between">
                                  <div className="mb-2 text-light-grey2">Token Name:</div>
                                  <div className="fw-bold mb-2">{token.tokenName}</div>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <div className="mb-2 text-light-grey2">Token Address:</div>
                                  <div className="text-info text-truncate mb-2" title={token.tokenAddress}>{token.tokenAddress}</div>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <div className="mb-2 text-light-grey2">Purchased Amount:</div>
                                  <div className="fw-bold mb-2">{token.purchasedAmount}</div>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <div className="mb-2 text-light-grey2">Current Balance:</div>
                                  <div className="fw-bold mb-2">{token.currentBalance}</div>
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                        ))}
                      </Row>

                      <Pagination className="justify-content-end gap-2">
                        <Pagination.Prev disabled={activePage === 1} onClick={() => handlePageChange(activePage - 1)} />
                        {[...Array(totalPages)].map((_, i) => (
                          <Pagination.Item
                            key={i}
                            active={i + 1 === activePage}
                            onClick={() => handlePageChange(i + 1)}
                            className="rounded-4"
                          >
                            {i + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next disabled={activePage === totalPages} onClick={() => handlePageChange(activePage + 1)} />
                      </Pagination>
                    </Container>}
                  {/* --------Duration Modal Start-------- */}
                  <Modal show={show} onHide={handleClose} className="modalStyle">
                    <Modal.Header closeButton>
                      <Modal.Title>Duration</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div>
                        <div className="fw-medium mb-3">
                          Token Name: {selectedItem.token_name}
                        </div>
                        <div className="fw-medium mb-3">
                          Token Address: {selectedItem.token_address}
                        </div>
                        <Form.Group>
                          <Form.Label>Enter New Duration</Form.Label>
                          <Form.Control
                            type="text"
                            name="duration"
                            placeholder="Value"
                            value={request.duration}
                            onChange={handleInputChange}
                            isInvalid={!!errors.duration}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.duration}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <p className="text-muted small fst-italic">
                        Note - New duration will not be added to existing duration
                      </p>
                      <Button
                        variant="dark"
                        onClick={(e) => handleUpdateDuration(e)}
                      >
                        UPDATE
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  {/* -------Withdraw  Modal Start------- */}
                  <Modal
                    show={withdraw}
                    onHide={handleClose2}
                    className="modalStyle"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Withdraw</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div>
                        <div className="fw-medium mb-3">
                          Token Name: {selectedItem.token_name}
                        </div>
                        <div className="fw-medium mb-3">
                          Token Address: {selectedItem.token_address}
                        </div>
                        <Form.Group>
                          <Form.Label>Reason for Withdrawal</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            type="text"
                            name="reason"
                            placeholder="text"
                            value={request.reason}
                            onChange={handleInputChange}
                            isInvalid={!!errors.reason}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.reason}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="dark" onClick={handleWithdrawRequest}>
                        SEND
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
                {/* <Footer /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Newpresale;
